module.exports = __webpack_public_path__ + "static/media/viaappia.786135d8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/viaappia.JPG
// module id = 689
// module chunks = 0